import dom from "../../../../dist/jsx-render/dom"
import { PopupTextComponent } from "./PopupTextComponent";
import { WidgetMeasureText } from "../Widgets/WidgetMeasureText";
import { DynPopup } from "../../../Components/DynPopup";

export type PopupMeasureTextComponentProps = {
    widget: WidgetMeasureText;
}

export class PopupMeasureTextComponent extends PopupTextComponent {
    props: PopupMeasureTextComponentProps;

    constructor(props: PopupMeasureTextComponentProps) {
        super(props);
    }

    element: HTMLElement =
        <DynPopup size="fit" showCancelButton={true} showSaveButton={true} onSave={this.onSave}
            title={Resources['WidgetClient'].widgetMeasureText}>
            {this.renderTitle()}
            {this.renderEditor()}
            {"Resources: Daten aus der Maßnahme mit Platzhaltern im Format [UniqueId] anzeigen."}
            <div style={{ height: "10rem" }}></div>
        </DynPopup>
}